import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorDoesNotHaveFiscalZipCode extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Does not have zip code to enable automatic invoicing', options);
    }
}
export default InvestorDoesNotHaveFiscalZipCode;
